import { render, staticRenderFns } from "./IconsCell.vue?vue&type=template&id=2534c0d8&"
import script from "./IconsCell.vue?vue&type=script&lang=js&"
export * from "./IconsCell.vue?vue&type=script&lang=js&"
import style0 from "./IconsCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports